import { render, staticRenderFns } from "./Vegas.vue?vue&type=template&id=1edd885e&scoped=true"
import script from "./Vegas.vue?vue&type=script&lang=js"
export * from "./Vegas.vue?vue&type=script&lang=js"
import style0 from "./Vegas.vue?vue&type=style&index=0&id=1edd885e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd885e",
  null
  
)

export default component.exports